export default __webpack_public_path__ + "7037cef.png";